'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { StyledDataItem } from './MDataList.styles';
export const MDataList = ({ isBold: isInBoldList, isLoading, items, ...props })=>{
    if (isLoading) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(StyledDataItem, {
                    isLoading: true,
                    title: "",
                    value: ""
                }),
                /*#__PURE__*/ _jsx(StyledDataItem, {
                    isLoading: true,
                    title: "",
                    value: ""
                }),
                /*#__PURE__*/ _jsx(StyledDataItem, {
                    isLoading: true,
                    title: "",
                    value: ""
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("ul", {
        children: items.map(({ color, isBold, title, value })=>/*#__PURE__*/ _createElement(StyledDataItem, {
                ...props,
                color: color || undefined,
                isBold: isBold ?? false,
                isInBoldList: isInBoldList,
                key: `${title}+${value}`,
                title: title ?? '',
                value: value ?? ''
            }))
    });
};

//# sourceMappingURL=MDataList.js.map